import env from '~/env'

import { betterstackStatusPageResponseSchema } from './schema'

const BASE_ERROR_MESSAGE = `Fetching Better Stack status page failed for tenant ${env.VITE_TENANT_NAME}`

export const fetchStatusPage = async (baseUrl: string) => {
    const url = `${baseUrl.replace(/\/+$/, '')}/index.json` // Ensure single trailing slash before 'index.json'
    let response

    try {
        response = await fetch(url)
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(`${BASE_ERROR_MESSAGE}. Response: ${error.message}`)
        } else {
            throw new Error(`Unknown error. ${BASE_ERROR_MESSAGE}`)
        }
    }

    if (!response.ok) {
        throw new Error(`${BASE_ERROR_MESSAGE}. Response: ${response.status}`)
    }

    return betterstackStatusPageResponseSchema.parse(await response.json())
}
